const theme = {
  themes: {
    light: {
      colorPrimary1: '#02092E',
      colorPrimary2: '#1F6ADA',
      colorPrimary3: '#A9B4F9',
      colorPrimary4: '#E97DF2',
      colorNeutral1: '#010311',
      colorNeutral2: '#333333',
      colorNeutral3: '#F1F1F1',
      colorNeutral4: '#F7F7FC',
      colorGradient1A: '#0A1553',
      colorGradient1B: '#02092E'
    }
  },
  dark: false,
  options: {
    customProperties: true,
  }
};

export default theme;